export const skillsConstants = [
  {
    category: "Frontend Technologies",
    skills: [
      "React.js",
      "Next.js",
      "TypeScript",
      "JavaScript (ES6+)",
      "HTML5",
      "CSS3",
      "Tailwind CSS",
      "Bootstrap",
      "React Redux",
    ],
  },
  {
    category: "Backend Technologies",
    skills: ["Node.js", "Express.js", "MongoDB"],
  },
  {
    category: "Testing & Development Tools",
    skills: [
      "React Testing Library",
      "Playwright",
      "Unit Testing",
      "Integration Testing",
      "End-to-End Testing",
      "Git",
      "GitHub",
      "Ubuntu Server Deployment",
    ],
  },
];
